/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The MSAL Id Token Key
 */
export const MSAL_IDTOKEN_KEY = "msal.idtoken";

/**
 * The MSAL Access Token Key
 */
export const MSAL_ACCESSTOKEN_KEY = "msal.accesstoken";

/**
 * Key to retrieve the locally stored url to redirect after authentication
 */
export const AAD_REPLYURL_SESSIONSTORAGE_KEY = "aad.redirect.url";

/**
 * The MSAL Access Token Key
 */
export const MICROSOFT_AAD_TENANT_ID = "72f988bf-86f1-41af-91ab-2d7cd011db47";
